import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() content: string | TemplateRef<unknown> = '';
  @Input() position: 'top' | 'bottom' = 'bottom';

  get isTemplate(): boolean {
    return this.content instanceof TemplateRef;
  }

  get templateContent(): TemplateRef<unknown> {
    return this.content as TemplateRef<unknown>;
  }

  get htmlString(): string {
    return this.content as string;
  }
}
